import { DateTime } from 'luxon';

export const DATE_PERIODS = ['all', 'today', '2d', '3d', '7d', '30d', 'custom'] as const;
export type DatePeriod = (typeof DATE_PERIODS)[number];
export type DateTimeRange = { start: number; end: number };
export type DateBounds = { from: Date | undefined; to?: Date };

const periodDays = { today: 1, '2d': 2, '3d': 3, '7d': 7, '30d': 30 } as const;

export const customDateRange = (from?: Date, to?: Date): DateTimeRange | undefined => {
    if (!from || !to) {
        return undefined;
    }
    const start = DateTime.fromJSDate(from).startOf('day');
    const lastDay = DateTime.fromJSDate(to).startOf('day');
    if (!start.isValid || !lastDay.isValid || lastDay < start) {
        return undefined;
    }
    return { start: start.toMillis(), end: lastDay.plus({ days: 1 }).toMillis() };
};

export const periodDateBounds = (period: Exclude<DatePeriod, 'custom'>, now: number): DateBounds | undefined => {
    if (period === 'all') {
        return undefined;
    }
    const start = DateTime.fromMillis(now).startOf('day');
    return { from: start.toJSDate(), to: start.plus({ days: periodDays[period] - 1 }).toJSDate() };
};

export const resolveDatePeriod = (period: Exclude<DatePeriod, 'custom'>, now: number): DateTimeRange | undefined => {
    const bounds = periodDateBounds(period, now);
    return customDateRange(bounds?.from, bounds?.to);
};
